import React from 'react';
import { MapPin, ShieldCheck, PlaneLanding } from 'lucide-react';

/** Tags, board, GPS flags — shared across feed / nearby / map cards. */
export default function ThreadMetaBadges({ thread, boardName }) {
  const tags = Array.isArray(thread.tags) ? thread.tags : [];
  const board = thread.board?.name || boardName;

  return (
    <div className="flex flex-wrap gap-1.5 mt-2">
      {board && (
        <span className="text-[10px] px-2 py-0.5 rounded-full border border-sky-500/40 bg-sky-500/10 text-sky-200">
          #{board}
        </span>
      )}
      {tags.map((tag) => (
        <span
          key={tag}
          className="text-[10px] px-2 py-0.5 rounded-full border border-dark-border bg-dark-surface text-dark-text-secondary"
        >
          {tag}
        </span>
      ))}
      {thread.gps_verified === 1 && (
        <span className="text-[10px] px-1.5 py-0.5 rounded border border-green-500/40 text-green-300 flex items-center gap-0.5">
          <ShieldCheck size={10} /> verified
        </span>
      )}
      {thread.arrival_based === 1 && (
        <span className="text-[10px] px-1.5 py-0.5 rounded border border-violet-500/40 text-violet-300 flex items-center gap-0.5">
          <PlaneLanding size={10} /> arrival
        </span>
      )}
      {thread.has_gps === 1 && thread.latitude != null && (
        <span className="text-[10px] px-1.5 py-0.5 rounded border border-dark-border text-dark-text-muted flex items-center gap-0.5">
          <MapPin size={10} /> GPS
        </span>
      )}
    </div>
  );
}
